if (!customElements.get('finimade-bundle')) {
customElements.define('finimade-bundle', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="radio"]')) return;
      const input = this.querySelector('[data-bundle-quantity]');
      input.value = event.target.value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
});
}